/*
saikrishna 11/24/2022 3031450488 Created a new Ui for Reports
saikrishna 11/25/2022  3031450488 Added BasicInfo new Ui fields
akhila 1/12/2022 3031450488 added new UI for workqueue
Suresh Peddavoora 12/05/2022 3031450488 Modified Landing Page Format.
Ashraf 12/05/2022 3031450488 Fixed header labels
Prakash 12/08/2022  3031450488 Removed card component.
Ashraf 12/13/2022 3031450488 Renamed header labels
Dilip 12/28/2022 3031450488 Renamed header labels
*/
import React, { useRef, useEffect, useState } from 'react';
import { Button, makeStyles, Stepper, StepLabel, Step, withStyles } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import reusableInputStyles from '../../../../components/InputStyles';
import axios from 'axios';
import PreviewFileDialog from '../../../../util/PreviewFileDialog';
import { useDispatch, useSelector } from 'react-redux';
import StepConnector from '@material-ui/core/StepConnector';
import { setAlertData } from '../../../../redux/reducers/UnsavedChangesAlertReducer';
import useUnsavedChangesWarning from '../../../../util/CustomHooks';
import { backButtonText, downloadButton } from '../../../../util/Content';
import { ResetMessage as resetMessage } from '../../../../redux/reducers/BRE/AddReportMaster';
import { ErrorSnackbar, SuccessSnackbar } from '../../../../components/CustomSnackBar';
import PageLoader from '../../../../components/PageLoader';
import { REPORTING_EXPORT, WORK_QUEUE_SETUP } from '../../../../constants/ReusableRoleAccess';
import { resetDownloadMsg } from '../../../../redux/reducers/PreviewFileData';
import NumberStepIcon from '../../../../components/customStepIcon';
import WorkQueueBasicInfo from './BasicInfo';
import Filters from './Filters';
import WorkqueueFields from './WorkqueueFields';
import moment from 'moment';
import {
  postPrintWorkqueueMaster,
  resetDockey,
  resetConfigUrl,
} from '../../../../redux/reducers/WorkQueueSetup';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  backButton: {
    marginRight: theme.spacing(1),
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  stepperIcon: {
    '& .MuiStepLabel-iconContainer': {
      '& .MuiStepIcon-root': {
        width: '35px !important',
        height: '35px !important',
      },
    },
    '& .MuiStepIcon-completed': {
      color: '#056c93',
    },
    '& .MuiStepIcon-active': {
      color: '#056c93',
    },
    '& .MuiStepLabel-labelContainer': {
      '& .MuiTypography-root': {
        fontSize: '1rem',
        fontWeight: 'bold',
        [theme.breakpoints.down('md')]: {
          fontSize: '0.75rem',
        },
      },
    },
  },
}));

const Workqueuesteps = ['Basic Info', 'Work Queue Fields', 'Filters'];
const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  active: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  completed: {
    '& $line': {
      borderColor: '#056c93',
    },
  },
  line: {
    borderColor: '#eaeaf0',
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);
const AddWorkQueue = ({ setTabValue, workQueue, setWorkQueue, editExisting }) => {
  const stepperClasses = useStyles();
  const dispatch = useDispatch();
  const classes = reusableInputStyles();
  const { isDraftReport, basicInfoData, lastStep, configurationUrl, dockey } = useSelector(
    ({ addWorkQueue }) => addWorkQueue,
  );
  const { isLoading, successMsg, errorMsg } = useSelector(({ addReportMaster }) => addReportMaster);
  const { roleData } = useSelector(({ role }) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  const roleAccess =
    (workQueue && basicInfoData?.reportCode && !workQueueSetupAccess?.edit && editExisting) ||
    (!workQueue && basicInfoData?.reportCode && !reportRoleAccess?.edit && editExisting);

  const [activeStep, setActiveStep] = React.useState(lastStep);
  const showAlertRef = useRef(false);
  const { routerPrompt, onDirty, onPristine } = useUnsavedChangesWarning();
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);
  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const changeDirty = useRef(true);
  
  // The save funcitonality on the step form
  const handleDirty = (dirty, isFixed) => {
    if (isFixed === 'fixed') {
      showAlertRef.current = dirty;
      changeDirty.current = false;
      // Are there unsaved changes?
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }


    if (isFixed === 'reset') {
      showAlertRef.current = false;
      changeDirty.current = true;
      onPristine();
    }

    if (changeDirty.current) {
      showAlertRef.current = dirty;
      if (dirty) {
        onDirty();
      } else {
        onPristine();
      }
    }
  };
  const alertProps = {
    showAlertRef,
    handleDirty,
  };
  
  const getStepContent = (index) => {
    switch (index) {
    case 0:
      return (
        <>
          <WorkQueueBasicInfo
            handleBack={handleBack}
            activeStep={activeStep}
            handleNext={handleNext}
            workQueue={workQueue}
            roleAccess={roleAccess}
            {...alertProps}
          />
        </>
      );
    case 1:
      return (
        <>
          <WorkqueueFields
            handleBack={handleBack}
            activeStep={activeStep}
            handleNext={handleNext}
            workQueue={workQueue}
            editExisting={editExisting}
            {...alertProps}
          />
        </>
      );
    case 2:
      return (
        <Filters
          handleNext={handleNext}
          handleBack={handleBack}
          workQueue={workQueue}
          setTabValue={setTabValue}
          editExisting={editExisting}
          {...alertProps}
        />
      );
    default:
      <p>InValid Step Index</p>;
    }
  };

  useEffect(() => {
    if (successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [successMsg, errorMsg]);

  useEffect(() => {
    if (configurationUrl) {
      setIsLoadingConfig(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoadingConfig(false);
      }
      readData();
    }
  }, [configurationUrl]);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Reporting/Export'}
        name={'Work Queue Name'}
        code={basicInfoData?.workqueueName}
        description={'Work Queue Description'}
        descriptionValue={basicInfoData?.workqueueDescription}
      />
      <div className="button-table-spacing-mb justify-content-between new-standard-textfields">
        <Button
          variant="outlined"
          type="button"
          className={`search-btn mx-1 ${classes.buttonRoot}`}
          onClick={() => {
            if (showAlertRef.current) {
              dispatch(
                setAlertData({
                  showAlert: showAlertRef.current,
                  alertCallback: () => {
                    setTabValue(0);
                  },
                }),
              );
            } else {
              setTabValue(0);
            }
          }}
        >
          <ArrowBack className="mr-2" />
          {backButtonText}
        </Button>
        {basicInfoData?.workqueueName && (
          <Button
            type="button"
            variant="outlined"
            className={`search-btn ml-2 ${classes.buttonRoot}`}
            onClick={() => {
              dispatch(
                postPrintWorkqueueMaster({
                  createdBy: basicInfoData?.createdBy ? basicInfoData?.createdBy : '',
                  createdDate: basicInfoData?.createdDate
                    ? moment(basicInfoData?.createdDate).format('MM/DD/YYYY')
                    : '',
                  isDraft: basicInfoData?.isDraft?.key ? basicInfoData?.isDraft?.key : '',
                  orderBy: '',
                  orderDirection: '',
                  workqueueDescription: basicInfoData?.workqueueDescription
                    ? basicInfoData.workqueueDescription
                    : '',
                  workqueueName: basicInfoData?.workqueueName ? basicInfoData.workqueueName : '',
                  printIndividual: 'Y',
                }),
              );
            }}
          >
            {downloadButton}
          </Button>
        )}
      </div>
      {routerPrompt}
      <div className={classes.root} style={{ border: '1px solid #cfcfcf' }}>
        <Stepper activeStep={activeStep} connector={<QontoConnector />}>
          {Workqueuesteps.map((label, i) => (
            <Step
              key={label}
              onClick={() => {
                if (
                  i < activeStep ||
                  i < lastStep ||
                  // (label !== "Schedule" && isDraftReport === "N") ||
                  isDraftReport === 'N' ||
                  i <= basicInfoData?.lastStep
                ) {
                  if (showAlertRef.current) {
                    dispatch(
                      setAlertData({
                        showAlert: showAlertRef.current,
                        alertCallback: () => {
                          setActiveStep(i);
                        },
                      }),
                    );
                  } else {
                    setActiveStep(i);
                  }
                }
              }}
              completed={
                i <= lastStep ||
                // (label !== "Schedule" && isDraftReport === "N") ||
                isDraftReport === 'N' ||
                i < activeStep ||
                i < basicInfoData?.lastStep
              }
              style={{ cursor: 'pointer' }}
            >
              <StepLabel
                className={`${stepperClasses.stepperIcon} ${
                  activeStep === i ? 'completedStyle' : null
                }`}
                StepIconComponent={NumberStepIcon}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
        <div>
          <div style={{ padding: '1.2rem 0.5rem' }}>{getStepContent(activeStep)}</div>
        </div>
      </div>
      {(isLoading || isLoadingConfig) && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default AddWorkQueue;
